import { useState, useEffect } from 'react';

const MESSAGES = [
  'Reading your CV...',
  'Finding your experience...',
  'Extracting your skills...',
  'Almost there, checking details...',
  'Taking a moment longer...',
];

interface ParsingAnimationProps {
  progress: number; // 0-100
  elapsedSeconds: number;
}

export function ParsingAnimation({ progress, elapsedSeconds }: ParsingAnimationProps) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => Math.min(prev + 1, MESSAGES.length - 1));
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const showSlowNote = elapsedSeconds > 30;

  return (
    <div className="onboarding-step" role="status" aria-live="polite">
      {/* Animated rings */}
      <div className="parsing-animation">
        <div className="parsing-animation__ring" />
        <div className="parsing-animation__ring" />
        <div className="parsing-animation__ring" />
        <div className="parsing-animation__center" />
      </div>

      {/* Rotating message */}
      <div className="parsing-message">
        <p className="parsing-message__text">{MESSAGES[messageIndex]}</p>
        {showSlowNote && (
          <p className="parsing-message__sub">
            This can take up to 2 minutes. Please keep this tab open.
          </p>
        )}
      </div>

      {/* Progress bar */}
      <div className="parsing-progress-bar" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
        <div
          className="parsing-progress-bar__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
